/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSquareAliasesRequest} from '@cash-web/protos/squareup/cash/staff/api/v1beta1/staff_linking_messages.pb'
import {GetSquareAliasesResponse} from '@cash-web/protos/squareup/cash/staff/api/v1beta1/staff_linking_messages.pb'


export const getSquareAliases = (request: GetSquareAliasesRequest, options?: CashRequestOptions) => post<GetSquareAliasesRequest, GetSquareAliasesResponse>("/cash-app/staff/linking/get-square-aliases", request, {...options, rejectOnError: true })